// extracted by mini-css-extract-plugin
module.exports = {"bulkInviteLink":"ImportUserListButton_bulkInviteLink_1kOoM"};